/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {TombOfAkhenatenServerDataParser} from "../TombOfAkhenatenServerDataParser";
import {ITombOfAkhenatenInitData} from "./ITombOfAkhenatenServerData";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {FeatureBuyTimesBetValue} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export class TombOfAkhenatenParsedInitData extends ParsedInitData {
    public get accumulatedRoundWin(): string {
        return this._accumulatedRoundWin;
    }
    public get featureBuyTimesBetValue(): FeatureBuyTimesBetValue[] {
        return this._featureBuyTimesBetValue;
    }
    get showPyramidsReel(): boolean[] {
        return this._showPyramidsReel;
    }

    private readonly _betWins: IBetWayWinData[] | undefined;

    private _stickySymbols:string[][] = [];
    private _showPyramidsReel: boolean[];

    get stickySymbols():string[][] {
        return this._stickySymbols;
    }

    private _activeRows:number;

    get activeRows():number {
        return this._activeRows;
    }

    private _activeRowsNextSpin:number;

    get activeRowsNextSpin():number {
        return this._activeRowsNextSpin;
    }

    private _payoutMultiplier:number;

    get payoutMultiplier():number {
        return this._payoutMultiplier;
    }

    private _payoutMultiplierBefore: number;

    get payoutMultiplierBefore(): number {
        return this._payoutMultiplierBefore;
    }

    private _payoutMultiplierNextSpin: number;
    private _featureBuyTimesBetValue : FeatureBuyTimesBetValue[];
    private _accumulatedRoundWin : string;

    constructor(rawData: ITombOfAkhenatenInitData, dataParser: TombOfAkhenatenServerDataParser) {
        super(rawData, dataParser);

        this._stickySymbols = dataParser.parseStickySymbols(rawData);
        this._activeRows = dataParser.parseActiveRows(rawData);
        this._activeRowsNextSpin = dataParser.parseActiveRowsNextSpin(rawData);
        this._payoutMultiplier = dataParser.parsePayoutMultiplier(rawData);
        this._payoutMultiplierBefore = dataParser.parsePayoutMultiplierBefore(rawData);
        this._payoutMultiplierNextSpin = dataParser.parsePayoutMultiplierNextSpin(rawData);
        this._betWins = dataParser.parseBetWinsOnInit(rawData);
        this._nearWinPositions = dataParser.parseNearWinPositions(rawData);
        this._showPyramidsReel = dataParser.getShowPyramidsReel(rawData);
        this._featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
        this._accumulatedRoundWin = rawData.accumulatedRoundWin;
    }

    get payoutMultiplierNextSpin(): number {
        return this._payoutMultiplierNextSpin;
    }

    private _nearWinPositions: boolean[][];

    get nearWinPositions(): boolean[][] {
        return this._nearWinPositions;
    }

    get betWins(): IBetWayWinData[] | undefined {
        return this._betWins;
    }
}